module.exports = __webpack_public_path__ + "static/media/ShiningStar.f62ad714.jpeg";